import { Link } from "react-router-dom";
import { ChevronLeft } from "lucide-react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { useEffect } from "react";

export default function LegalLayout({ title, intro, children, testId }) {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    return (
        <div data-testid={testId} className="min-h-screen bg-brand-cream">
            <Header />
            <main className="pt-32 pb-20">
                <div className="mx-auto max-w-3xl px-5 sm:px-8">
                    <Link
                        to="/"
                        className="inline-flex items-center gap-1.5 text-sm font-medium text-brand-blue-700 hover:text-brand-navy mb-8"
                        data-testid="legal-back-home"
                    >
                        <ChevronLeft className="h-4 w-4" /> Volver al inicio
                    </Link>
                    <h1 className="font-display font-bold text-4xl sm:text-5xl text-brand-navy tracking-tight">
                        {title}
                    </h1>
                    {intro && (
                        <p className="mt-5 text-base sm:text-lg text-brand-ink/70 leading-relaxed">
                            {intro}
                        </p>
                    )}
                    <div className="mt-10 prose prose-slate max-w-none
                                    prose-headings:font-display prose-headings:text-brand-navy
                                    prose-h2:text-2xl prose-h2:mt-12 prose-h2:mb-4
                                    prose-h3:text-lg prose-h3:mt-8 prose-h3:mb-3
                                    prose-p:text-[15px] prose-p:leading-relaxed prose-p:text-brand-ink/80
                                    prose-li:text-[15px] prose-li:text-brand-ink/80
                                    prose-strong:text-brand-navy
                                    prose-a:text-brand-blue-700 prose-a:no-underline hover:prose-a:underline">
                        {children}
                    </div>
                </div>
            </main>
            <Footer />
        </div>
    );
}
